import React, {useState, useEffect} from 'react';

import acceptIcon from '../../../../assets/svg/tick.svg';
import closeIcon from '../../../../assets/svg/image-preview-close.svg';
import declineIcon from '../../../../assets/svg/cross.svg';
import questionMarkIcon from '../../../../assets/svg/question-icon.svg';
import VIDABOO_CONSTANTS from '../../../../config/consts';

import './textPillComponent.css';

const TextPillComponent = ({
  hideDeleteIcon = false,
  addTextPillInputRef = null,
  isAddEmailPill = false,
  showStatusIcon = true,
  email = '',
  recipientStatus = '',
  isValid = true,
  onChange = () => {},
  onKeyDown = () => {},
  onDoubleClick = () => {},
  removeRecipient = () => {},
}) => {
  const SINGLE_CLICK_DELAY = 200;
  const [isFocused, setIsFocused] = useState(false);
  const [singleClickTimeout, setSingleClickTimeout] = useState(0);
  const [textPillStatusIcon, setTextPillStatusIcon] = useState(
    questionMarkIcon,
  );
  useEffect(() => {
    if (recipientStatus) {
      const textPillStatusIcon =
        recipientStatus === VIDABOO_CONSTANTS.BOOKING_FLOW_USER_STATES.CONFIRMED
          ? acceptIcon
          : recipientStatus ===
            VIDABOO_CONSTANTS.BOOKING_FLOW_USER_STATES.CREATED
          ? questionMarkIcon
          : declineIcon;
      setTextPillStatusIcon(textPillStatusIcon);
    }
    return () => {
      if (singleClickTimeout) clearTimeout(singleClickTimeout);
    };
  }, []);

  const handleNonEditableEmailSingleClick = () => {
    if (singleClickTimeout) clearTimeout(singleClickTimeout);
    const timeout = setTimeout(() => {
      setIsFocused(true);
    }, SINGLE_CLICK_DELAY);
    setSingleClickTimeout(timeout);
  };

  const handleNonEditableEmailDoubleClick = () => {
    if (singleClickTimeout) clearTimeout(singleClickTimeout);
    onDoubleClick(email);
  };

  return (
    <div className="et-n-epc-container">
      <div
        className={`
          ${
            isAddEmailPill
              ? 'et-n-epc-add-pill-input-email-wrap'
              : 'et-n-epc-input-email-wrap'
          } ${isFocused ? 'et-n-epc-input-email-wrap-edit-mode' : ''} ${
          !isValid ? 'et-n-epc-email-input-erroneous-wrap' : ''
        }  ${hideDeleteIcon ? 'et-n-epc-padding-right' : ''}`}>
        {!isFocused && !isAddEmailPill && (
          <>
            {showStatusIcon && (
              <img
                className="et-n-epc-status-icon-img"
                src={textPillStatusIcon}
                alt={'iconImg'}
              />
            )}
            <div
              className={`et-n-epc-email-text ${
                !isValid ? 'et-n-epc-email-text-erroneous' : ''
              }`}
              onClick={handleNonEditableEmailSingleClick}
              onDoubleClick={handleNonEditableEmailDoubleClick}>
              {email}
            </div>
          </>
        )}
        {(isFocused || isAddEmailPill) && (
          <input
            ref={addTextPillInputRef}
            autoFocus={!isAddEmailPill}
            className={`et-n-epc-email-input ${
              isFocused ? 'et-n-epc-email-input-edit-mode' : ''
            } ${!isValid ? 'et-n-epc-email-text-erroneous' : ''}`}
            style={{
              width: email.length + 1 + 'ch',
            }}
            type="text"
            value={email}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ',' || e.key === ';') {
                setIsFocused(false);
                onKeyDown(e.key);
              }
            }}
            onBlur={() => {
              setIsFocused(false);
            }}
            onDoubleClick={() => {
              onDoubleClick(email);
            }}
          />
        )}
        {!isAddEmailPill && !hideDeleteIcon && (
          <div
            className="et-n-epc-delete-icon"
            onClick={() => {
              removeRecipient(email);
            }}>
            <img src={closeIcon} alt={'closeIcon'} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TextPillComponent;
